import React from 'react';

const Portfolio = () => {
  return <section className='section bg-green-200'>Portfolio</section>;
};

export default Portfolio;
